import React from 'react';
import VehiclePathCard from './VehiclePathCard';

const VehiclePathGrid = ({ 
  vehiclePaths, 
  selectedVehicleIndex, 
  maxCapacity, 
  startId, 
  pathComplete, 
  selectVehiclePath, 
  resetVehiclePath, 
  removePointFromPath,
  vehicleCount,
  handleVehicleCountChange,
  locations,
  undoLastPoint
}) => {
  return (
    <div className="vehicle-paths-container">
      <div className="vehicle-paths-header">
        <h4>Vehicle Paths:</h4>
        
        {/* Vehicle count selector */}
        <div className="vehicle-count-selector">
          <label htmlFor="vehicle-count">Number of Vehicles:</label>
          <div className="vehicle-count-controls">
            <input
              id="vehicle-count"
              type="number"
              min="1"
              max="50"
              value={vehicleCount}
              onChange={(e) => {
                const count = parseInt(e.target.value, 10);
                if (!isNaN(count) && count >= 1 && count <= 50) {
                  handleVehicleCountChange(count);
                }
              }}
              className="vehicle-count-input"
            />
          </div>
        </div>
      </div>
      
      {selectedVehicleIndex !== null && (
        <p className="vehicle-selection-hint">
          Currently editing path of vehicle {selectedVehicleIndex + 1}
        </p>
      )}
      
      <div className="vehicle-paths-list">
        {vehiclePaths.map((vehicle, index) => (
          <VehiclePathCard
            key={vehicle.id}
            vehicle={vehicle}
            index={index}
            selectedVehicleIndex={selectedVehicleIndex}
            maxCapacity={maxCapacity}
            startId={startId}
            pathComplete={pathComplete}
            selectVehiclePath={selectVehiclePath}
            resetVehiclePath={resetVehiclePath}
            removePointFromPath={removePointFromPath}
            locations={locations}
            undoLastPoint={undoLastPoint}
          />
        ))}
      </div>
    </div>
  );
};

export default VehiclePathGrid; 